<main class="main">
  <div id="sidenav">
    <app-sidenav></app-sidenav>
  </div>
  <div id="content">
    <router-outlet></router-outlet>
  </div>
</main>